import * as R from 'ramda';

export default function UploadSchematicsDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  bcpDataService,
  bcpSharedModelService,
  loaderService,
  ssDialogService
) {
  const vm = this;
  
  vm.defaultNameText = 'The uploaded files will use the uploaded file name as the default document name.';

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleFileAdd = _handleFileAdd;
  vm.handleValidateFileAsync = _handleValidateFileAsync;
  vm.handleFormSubmit = _handleFormSubmit;
  
  vm.selectedSection = null;
  
  vm.files = [];
  vm.uploadProgress = 0;
  vm.validatedFileNames = [];

  _activate();

  function _handleCloseDialog() {
    _closeDialog();
  }

  // eslint-disable-next-line no-unused-vars
  function _handleFileAdd($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
    vm.uploadProgress = 0;
    vm.validatedFileNames = [];
  }

  // Note: This gets called for each file that gets added.
  function _handleValidateFileAsync($file, form) {
    const dfdDocumentExists = $q.defer();

    $q.all([
      bcpDataService.checkSchematicExists(vm.assessmentId, -1, $file.name),
      bcpDataService.checkSchematicFileNameExists(vm.assessmentId, -1, $file.name)
    ]).then((response) => {
      if (response[0].data.result) {
        alerts.error(`File already exists with the name "${$file.name}". Duplicate names not allowed within the schematic list.`);
        $timeout(() => { _removeDocumentByName($file.name, form); }, 0);
      } else if (response[1].data.result) {
        alerts.error(`File already exists with the filename "${$file.name}". Duplicate filenames not allowed within the schematics directory.`);
        $timeout(() => { _removeDocumentByName($file.name, form); }, 0);
      } else if (vm.validatedFileNames.includes($file.name)) {
        alerts.error(`File with the filename "${$file.name}" already exists in the current request.`);
        $timeout(() => { _removeDocumentByName($file.name, form); }, 0);
      } else {
        vm.validatedFileNames.push($file.name);
        vm.files.push($file);
      }

      dfdDocumentExists.resolve(!documentExistsResponse.data.result);
    });
    return dfdDocumentExists.promise;
  }

  function _removeDocumentByName(fileName, form) {
    vm.validatedFileNames.push(fileName);
    vm.files = vm.files.filter(file => file.name !== fileName);
    if (vm.files && vm.files.length > 0) {
      form.uploadFiles.$setValidity('required', true);
    } else {
      form.uploadFiles.$setValidity('required', false);
    }
  }

  function _handleFormSubmit() {
    const dfdSave = $q.defer();
    if (_isValid()) {
      loaderService.showViewLoader = true;

      return bcpDataService.uploadSchematics(vm.assessmentId, vm.schematicSectionId, vm.files).then((response) => {
        if (response.status === 201 || response.status === 200) {
          if (response.data[0].documentId > 0) {            
            alerts.success('The Schematic(s) have been saved successfully.');

            $rootScope.$broadcast('setDocumentRegenerateFlag');
            $rootScope.$broadcast('refreshBCPSchematics');

            _closeDialog();
          } else {
            alerts.error('An Error occurred while getting the uploaded Schematic information.');
          }
          dfdSave.resolve();
        } else {
          alerts.error('Error occurred while uploading file(s).');
          dfdSave.reject();
        }
      }, (response) => {
        if (response.status > 0) {
          alerts.error('Error occurred while uploading file(s).');
        }
      }, (event) => {
        vm.uploadProgress = Math.min(100, parseInt(100.0 * event.loaded / event.total, 10));
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
    }
  }

  function _activate() {
    loaderService.showViewLoader = true;
    return bcpSharedModelService.getSchematicSections(true).then((schematicSections) => {
      loaderService.showViewLoader = false;
      vm.schematicSections = schematicSections;

      R.forEach((schematicSection) => {
        if (schematicSection.schematicSectionId === vm.schematicSectionId) {
          vm.selectedSection = schematicSection;
        }
      }, vm.schematicSections);
    });
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.uploadSchematicsDialog);
  }

  function _isValid() {
    let isValid = true;
    
    if (vm.files != null || vm.files.length > 0) {
      vm.documentPresent = true;
    } else {
      isValid = false;
      vm.documentPresent = false;
    }

    return isValid;
  }
}

UploadSchematicsDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'bcpDataService',
  'bcpSharedModelService',
  'loaderService',
  'ssDialogService'
];
